import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant'
import * as actions from '../action';

function SupersededAssessmentModal({
  createInput,
  applicationId,
  id,
  updateRecordOfSupAssessment,
  formData,
  setFormData,
  getRecordOfSupAssessmentList,
  updateList,
  type,
  createRecordOfSupAssessment,
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      effectivity_of_assessment: `${moment(_.get(formData, 'effectivity_of_assessment')).format(
        'YYYY-MM-DD'
      )}`,
      date: `${moment(_.get(formData, 'date')).format(
        'YYYY-MM-DD'
      )}`,
    }

    if (type === 'NEW') {
      createRecordOfSupAssessment(applicationId, args, () => {
        setModal({ isOpen: false });
        getRecordOfSupAssessmentList(applicationId);
      });
    }

    if (type === 'EDIT') {
      updateRecordOfSupAssessment(applicationId, id, args, () => {
        setModal({ isOpen: false });
        getRecordOfSupAssessmentList(applicationId);
      });
    }

  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.SUP_ASSESSMENT_FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            {createInput(
              { key: 'pin', label: 'Pin:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'arp_no', label: 'ARP No.:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'td_no', label: 'TD No.:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'total_assessed_value', label: 'Total Assessed Value:' },
              { required: true, type: 'number' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'previous_owner', label: 'Previous Owner:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="form-input-group col-6">
            <label className="form-control-plaintext">Effectivity of Assessment:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('effectivity_of_assessment')}
              value={`${moment(_.get(formData, 'effectivity_of_assessment')).format('MM-DD-YYYY')}` || ''}
            />
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'ar_page_no', label: 'AR Page No.:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-6 form-group">
            {createInput(
              { key: 'recording_person', label: 'Recording Person:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="form-input-group col-6">
            <label className="form-control-plaintext">Date:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={`${moment(_.get(formData, 'date')).format('MM-DD-YYYY')}` || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

SupersededAssessmentModal.defaultProps = {
  type: '',
  id: '',
  applicationId: '',
  updateList: {},
};

SupersededAssessmentModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  getRecordOfSupAssessmentList: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object),
  updateRecordOfSupAssessment: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createRecordOfSupAssessment: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SupersededAssessmentModal);
